import Rete from 'rete';

import { distSocket } from './index';

import samplingNumber from '../../util/density/samplingNumber';
import timeSlices from '../../util/density/timeSlices';
import fillArray from '../../util/density/fillArray';

import ResultControl from './ResultControl';
import SelectControl from './SelectControl';


export default class ResultComponent extends Rete.Component {

	constructor(){
		super("Result");
		this.path = ["Operation"];
		this.contextMenuName = "Result";
	}

	builder(node) {
		let inp1 = new Rete.Input('dist1',"Input 1", distSocket);
		let out1 = new Rete.Output('out1', 'Number', distSocket);
		let control1 = new ResultControl(this.editor, 'result', true, node.id);
		
		node.addInput(inp1);
		node.addOutput(out1);
		node.addControl(control1);
		return node;
	}

	async worker(node, inputs, outputs) {
		let result = JSON.stringify(inputs['dist1'][0]);
		
		// update result if node on screen (in editor)
		let nodeSearch = this.editor.nodes.find(n => n.id == node.id);
		if (nodeSearch) {
			nodeSearch.controls.get('result').setValue(result);
		}
		outputs['out1'] = result;
	}
}
